@if (surveyEditor$().activeQuestion; as activeQuestion) {
  <form [formGroup]="activeQuestion">
    <div class="question-form__array">
      <div class="header">
        <span class="ai-chat-form__header-label text__md fw__600">AI configuration</span>
      </div>

      <div class="ai-chat-form__discussion-guide">
        <span class="ai-chat-form__discussion-guide-label text__sm fw__500">Discussion guide</span>
        <textarea
          cdkTextareaAutosize
          [cdkAutosizeMinRows]="4"
          [cdkAutosizeMaxRows]="20"
          class="text__md ai-chat-form__discussion-guide-textarea"
          placeholder="Enter a description..."
          formControlName="discussionGuide"
          autocomplete="off"
        ></textarea>
      </div>
      <span class="ai-chat-form__sublabel text__sm"
        >Paste key topics or a full guide. The AI uses this to steer follow-up questions, especially when a respondent gives a brief answer.</span
      >

      <div class="ai-chat-form__prompts-number">
        <div class="ai-chat-form__counter-wrapper">
          <span class="ai-chat-form__counter-label text__sm fw__500">Min follow-up</span>
          <eiq-counter [value]="activeQuestion.get('minPromptsNumber')?.value ?? 0" (setCount)="activeQuestion.get('minPromptsNumber')?.setValue($event)" />
          <span class="ai-chat-form__counter-sublabel text__sm">Ensures depth in every response</span>
        </div>
        <div class="ai-chat-form__counter-wrapper">
          <span class="ai-chat-form__counter-label text__sm fw__500">Max follow-up</span>
          <eiq-counter [value]="activeQuestion.get('promptsNumber')?.value ?? 0" (setCount)="activeQuestion.get('promptsNumber')?.setValue($event)" />
          <span class="ai-chat-form__counter-sublabel text__sm">Prevents participant fatigue</span>
        </div>
      </div>
    </div>
  </form>
}
